/**
 * onboardingProgress — the SINGLE authoritative source for every onboarding
 * progress number shown to a customer. Both the live MEISAI registration
 * console and the dashboard onboarding surfaces (on-page panel + topbar pill)
 * derive their percentage AND their "Step X of N" counter from these pure
 * functions, so a percentage can NEVER contradict its step count again
 * (previously: console "6% / Step 1 of 8"; panel "2/5" vs pill "3/4").
 */

// ── Live MEISAI registration console (stage rail) ──────────────────────────
// currentStep and pct both come from the SAME fraction (currentStep/total),
// so "Step X/N" and the % are always consistent.
export function liveConsoleProgress(stageIdx, totalSteps, isDone = false) {
  const total = Math.max(1, totalSteps || 1);
  const currentStep = Math.min(Math.max(stageIdx + 1, 1), total);
  const pct = isDone ? 100 : Math.round((currentStep / total) * 100);
  return { currentStep, totalSteps: total, pct };
}

// ── Dashboard onboarding wizard (panel + topbar pill) ──────────────────────
// 5 user-visible steps: account_ready, meisai_connect, cards_confirm,
// schedule, done. account_ready + schedule are always complete (2). The
// meisai_connect + cards_confirm pair flips together with meisaiStepDone (+2).
// The terminal "done" step flips on complete (+1).
export const ONBOARDING_TOTAL_STEPS = 5;

export function onboardingSetupProgress({ meisaiStepDone = false, complete = false } = {}) {
  const done = 2 + (meisaiStepDone ? 2 : 0) + (complete ? 1 : 0);
  const total = ONBOARDING_TOTAL_STEPS;
  return { done, total, pct: Math.round((done / total) * 100) };
}
